import axios from "axios";
import { toast } from "react-toastify";
import { notifyNetworkError, notifyNetworkRecovered } from "../networkStatus";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
});
const cookie = "sessionid=abcdef123456";

axiosInstance.interceptors.response.use(
  (response) => {
    notifyNetworkRecovered();
    return response;
  },
  (error) => {
    if (!error.response || error.code === "ERR_NETWORK") {
      const networkMessage =
        error.message === "Network Error"
          ? "Aktuell besteht keine Verbindung zum Server."
          : error.message || "Unbekannter Netzwerkausfall.";
      notifyNetworkError(networkMessage);
    }
    return Promise.reject(error);
  }
);

export const getHomeInfoAPI = async () => {
  try {
    const res = await axiosInstance.get("/home/info", {
      headers: {
        Cookie: cookie,
      },
    });
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const getHomeDealsAPI = async () => {
  try {
    const res = await axiosInstance.get("/home/deals", {
      headers: {
        Cookie: cookie,
      },
    });
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const getHomeTimeAPI = async () => {
  try {
    const res = await axiosInstance.get("/home/time", {
      headers: {
        Cookie: cookie,
      },
    });
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const getShowOnboardingVideoAPI = async () => {
  try {
    const res = await axiosInstance.get("/home/show_onboarding", {
      headers: {
        Cookie: cookie,
      },
    });
    return res.data;
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
};

export const getCheckAuthAPI = async () => {
  try {
    const res = await axiosInstance.get("/check_auth", {
      headers: {
        Cookie: cookie,
      },
    });
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const getLoginRedirectAPI = async () => {
  try {
    const res = await axiosInstance.get(
      "/login?redirect_uri=" + window.location.origin + "/oauth"
    );
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const requestOtpAPI = async (identifier) => {
  try {
    const res = await axiosInstance.post("/request_otp", { identifier });
    return res.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || error.message);
    throw error;
  }
};

export const submitOtpAPI = async ({ identifier, code }) => {
  try {
    const res = await axiosInstance.post("/submitt_otp", { identifier, code });
    return res.data;
  } catch (error) {
    toast.error(error?.response?.data?.message || error.message);
    throw error;
  }
};

export const getAuthCodeAPI = async (token) => {
  try {
    const res = await axiosInstance.get(
      "/oauth?code=" +
      token +
      "&redirect_uri=" +
      window.location.origin +
      "/oauth",
      {
        headers: {},
      }
    );
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const getLogoutRedirectAPI = async () => {
  try {
    const res = await axiosInstance.get("/logout");
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const getOverviewAPI = async () => {
  try {
    const res = await axiosInstance.get("/overviewData");
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const getSpyProductDetailsAPI = async (asin) => {
  try {
    const res = await axiosInstance.get(`/spy_detail?asin=${asin}`);
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export let getFilterAPI = async (application) => {
  try {
    const res = await axiosInstance.get(
      `/get_filter?application=${application}`
    );
    return res.data
  } catch (error) {
    toast.error(error.message)
  }
}

export let getCurrentFilterAPI = async (application) => {
  try {
    const res = await axiosInstance.get(
      `/get_current_filter?application=${application}`
    );
    return res.data;
  } catch (error) {
    toast.error(error.message)
  }
}

export let updateFilterAPI = async (
  application,
  filter_id,
  filter_type,
  attribute,
) => {
  try {
    const res = await axiosInstance.get(`/update_filter`, {
      params: {
        application,
        filter_id,
        filter_type,
        attribute,
      }
    });
    return res.data
  } catch (error) {
    toast.error(error.message)
  }
}

export let resetFilterAPI = async (
  application,
  filter_id,
  filter_type,
) => {
  try {
    const res = await axiosInstance.get(`/reset_filter`, {
      params: {
        application,
        filter_id,
        filter_type,
      }
    })
    return res.data;
  } catch (error) {
    toast.error(error.message)
  }
}

export let createPresetAPI = async (
  application,
  preset_name,
) => {
  try {
    const res = await axiosInstance.get(`/create_preset`, {
      params: {
        application,
        preset_name,
      }
    })
    return res.data;
  } catch (error) {
    toast.error(error.message)
  }
}

export let deletePresetAPI = async (
  application,
  preset_id,
) => {
  try {
    const res = await axiosInstance.get(`/delete_preset`, {
      params: {
        application,
        preset_id,
      }
    })
    return res.data;
  } catch (error) {
    toast.error(error.message)
  }
}

export let applyPresetAPI = async (
  application,
  preset_id,
) => {
  try {
    const res = await axiosInstance.get(`/apply_preset`, {
      params: {
        application,
        preset_id,
      }
    })
    return res.data;
  } catch (error) {
    toast.error(error.message)
  }
}


export let updatePresetAPI = async (
  application,
  preset_id,
) => {
  try {
    const res = await axiosInstance.get(`/update_preset`, {
      params: {
        application,
        preset_id,
      }
    })
    return res.data;
  } catch (error) {
    toast.error(error.message)
  }
}


export const getNotificationsAPI = async (application) => {
  try {
    const res = await axiosInstance.get('/get_notifications', {
      params: { application },
    })
    return res.data
  } catch (error) {
    toast.error(error.message)
    throw error
  }
}


export const updateNotificationsAPI = async ({
  application,
  preset_id,
  notification,
  markets = [],
}) => {
  try {
    const toParamValue = (value) => (value ? 'True' : 'False')
    const params = {
      application,
      notification: toParamValue(Boolean(notification)),
      de: toParamValue(markets.includes('de')),
      it: toParamValue(markets.includes('it')),
      es: toParamValue(markets.includes('es')),
      fr: toParamValue(markets.includes('fr')),
    }

    params.preset_id = preset_id ?? 'None'

    const res = await axiosInstance.get('/update_notifications', { params })
    return res.data
  } catch (error) {
    toast.error(error.message)
    throw error
  }
}

export const getSubscriptionSettingsAPI = async () => {
  try {
    const res = await axiosInstance.get("/settings/subscription");
    return res.data;
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
};

export const getVaAccessListAPI = async () => {
  try {
    const res = await axiosInstance.get("/settings/va_access/list");
    return res.data;
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
};

export const getAmazonIntegrationUrlAPI = async () => {
  try {
    const res = await axiosInstance.get("/integration/amazon/url");
    return res.data;
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
};

export const getDiscordIntegrationUrlAPI = async (redirectUri) => {
  try {
    const res = await axiosInstance.get("/integration/discord/url", {
      params: {
        redirect_uri: redirectUri,
      },
    });
    return res.data;
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
};

export const completeDiscordIntegrationOAuthAPI = async (code) => {
  try {
    const redirectUri =
      typeof window !== "undefined"
        ? `${window.location.origin}/integration/discord/oauth`
        : "";

    const res = await axiosInstance.get("/integration/discord/oauth", {
      params: {
        code,
        redirect_uri: redirectUri,
      },
    });
    return res.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error.message ||
      "Discord-Verknüpfung konnte nicht abgeschlossen werden.";
    toast.error(message);
    throw error;
  }
};

export const completeAmazonIntegrationOAuthAPI = async ({
  state,
  sellingPartnerId,
  spapiOauthCode,
}) => {
  try {
    const res = await axiosInstance.get("/integration/amazon/oauth", {
      params: {
        state,
        selling_partner_id: sellingPartnerId,
        spapi_oauth_code: spapiOauthCode,
      },
    });
    return res.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error.message ||
      "Seller Central-Verknüpfung konnte nicht abgeschlossen werden.";
    toast.error(message);
    throw error;
  }
};

export const addVaAccessAPI = async ({ vaType, vaIdentifier }) => {
  try {
    const params = {
      va_type: vaType,
      va_identifier: vaIdentifier,
    };
    const res = await axiosInstance.get("/settings/va_access/add", {
      params,
    });
    return res.data;
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
};

export const removeVaAccessAPI = async ({ vaType, vaIdentifier }) => {
  try {
    const params = {
      va_type: vaType,
      va_identifier: vaIdentifier,
    };
    const res = await axiosInstance.get("/settings/va_access/remove", {
      params,
    });
    return res.data;
  } catch (error) {
    toast.error(error.message);
    throw error;
  }
};


export const changeFilterAPI = async (
  application,
  type,
  attribute,
  preset_name
) => {
  const apiUrl = preset_name
    ? `/update_filter?application=${application}&type=${type}&attribute=${encodeURIComponent(
      attribute
    )}&preset_name=${preset_name}`
    : `/update_filter?application=${application}&type=${type}&attribute=${encodeURIComponent(
      attribute
    )}`;

  try {
    const res = await axiosInstance.get(apiUrl);
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const getSpyProductsAPI = async (page = 0, limit = 10) => axiosInstance.get(`/spy_products?page=${page}&limit=${limit}`)


export const getSellerTrackingAPI = async () => {
  try {
    const res = await axiosInstance.get("/tracked_seller");
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const addSellerTrackingAPI = async (sellername, sellerid) => {
  try {
    const res = await axiosInstance.get(
      `/add_seller?sellername=${sellername}&sellerid=${sellerid}`
    );
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const deleteSellerTrackingAPI = async (sellerid) => {
  try {
    const res = await axiosInstance.get(`/delete_seller?sellerid=${sellerid}`);
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const getA2AProductsAPI = async (productType, offSet) => {
  try {
    const res = await axiosInstance.get(`/${productType}?offset=${offSet}`);
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const priceAlertInfoAPI = async (type) => {
  try {
    const res = await axiosInstance.get(`${type}`);
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const addPriceAlertAPI = async (type, file) => {
  try {
    const res = await axiosInstance.post(`/${type}`, file);
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const deleteAllPriceAlertAPI = async (type) => {
  try {
    const res = await axiosInstance.get(`/${type}`);
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export const getPriceAlertsWatchlistAPI = async () => {
  try {
    const res = await axiosInstance.get("/pricealerts_watchlist", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Error fetching watchlist:", error);
    toast.error(error.message);
    return { status: "error", message: error.message };
  }
};

export const deleteAsinsBatchAPI = async (asins) => {
  try {
    const res = await axiosInstance.post(
      "/pricealerts_delete_asins",
      { asins },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error batch-deleting ASINs:", error);
    toast.error(error.message);
    return { status: "error", message: error.message };
  }
};

export const getBlacklistAPI = async () => {
  try {
    const res = await axiosInstance.get("/pricealerts_blacklist", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Error fetching blacklist:", error);
    toast.error(error.message);
    return { status: "error", message: error.message };
  }
};

export const addToBlacklistAPI = async (asins) => {
  try {
    const res = await axiosInstance.post(
      "/pricealerts_blacklist_add",
      { asins },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error adding to blacklist:", error);
    toast.error(error.message);
    return { status: "error", message: error.message };
  }
};

export const removeFromBlacklistAPI = async (asins) => {
  try {
    const res = await axiosInstance.post(
      "/pricealerts_blacklist_remove",
      { asins },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error removing from blacklist:", error);
    toast.error(error.message);
    return { status: "error", message: error.message };
  }
};

export const addSingleAsinAPI = async (asin) => {
  console.log("asin", typeof asin);
  try {
    const res = await axiosInstance.post(
      "/pricealerts_add_asins",
      {
        asins: [asin],
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Add ASIN response:", res.data);
    return res.data;
  } catch (error) {
    console.error("Error adding ASIN:", error);
    toast.error(error.message);
    return { status: "error", message: error.message };
  }
};

export const deleteSingleAsinAPI = async (asin) => {
  try {
    const res = await axiosInstance.post(
      "/pricealerts_delete_asins",
      {
        asins: [asin],
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Delete ASIN response:", res.data);
    return res.data;
  } catch (error) {
    console.error("Error deleting ASIN:", error);
    toast.error(error.message);
    return { status: "error", message: error.message };
  }
};

export const exportAsinsAPI = async () => {
  try {
    const res = await axiosInstance.get("/export_csv_pricealerts", {
      headers: {
        Accept: "text/csv",
        "Content-Type": "text/csv",
      },
    });

    // If we get an unauthorized response
    if (typeof res.data === "object" && res.data.status === "unauthorized") {
      return res.data;
    }

    // If we get a CSV string, parse it to extract ASINs
    const lines = res.data.split("\n");
    const asins = lines
      .slice(1) // Skip header row
      .map((line) => {
        const parts = line.split(",");
        // Join all parts to handle cases where commas split the ASIN
        return parts.join("").trim();
      })
      .filter((asin) => asin.length > 0); // Remove empty lines

    if (asins.length === 0) {
      toast.warning("No data available to export");
      return { status: "error", message: "No data available to export" };
    }

    // Create a new CSV with proper formatting
    const csvContent = [
      "ASIN", // Header
      ...asins,
    ].join("\n");

    // Create a blob with proper CSV formatting
    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    return blob;
  } catch (error) {
    console.error("Error exporting ASINs:", error);
    toast.error(error.message);
    return { status: "error", message: error.message };
  }
};

export const getPriceAlertInfoAPI = async () => {
  try {
    const res = await axiosInstance.get("/price_alert_info_pricealerts", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    console.log("Price Alert Info response:", res.data);
    return res.data;
  } catch (error) {
    console.error("Error getting price alert info:", error);
    toast.error(error.message);
    return { status: "error", message: error.message };
  }
};

export const searchPriceAlertsWatchlistAPI = async (asin) => {
  try {
    const res = await axiosInstance.get(
      `/pricealerts_watchlist_search?asin=${asin}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error searching price alerts watchlist:", error);
    toast.error(error.message);
    return { status: "error", message: error.message };
  }
};

export const getPriceAlertsProductsAPI = async (page = 0, limit = 10) => {
  try {
    const res = await axiosInstance.get(
      `/pricealerts_products?page=${page}&limit=${limit}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching price alerts products:", error);
    toast.error(error.message);
    throw error;
  }
};

export const toggleActionButtonAPI = async (
  action,
  module,
  type,
  asin,
  ping_id
) => {
  try {
    const res = await axiosInstance.get(`/action_button`, {
      params: {
        action,
        module,
        type,
        asin,
        ping_id,
      },
    });
    return res.data;
  } catch (error) {
    toast.error(error.message);
    return { status: "error", message: error.message };
  }
};

export let getWholesaleProductsAPI = async (
  listId,
  favoriteId,
  search,
  sortBy,
  sortType,
  page = 0,
  limit = 10,
  regions
) => {
  try {
    const params = {
      list_id: listId,
      favorite_id: favoriteId,
      search_attribute: search,
      sort_by: sortBy,
      sort_type: sortType,
      page,
      limit,
    }

    if (Array.isArray(regions) && regions.length) {
      params.regions = regions
    }

    const res = await axiosInstance.get(`/wholesale_wizard_products`, {
      params,
      paramsSerializer: {
        indexes: null,
      }
    })
    return res.data
  } catch (error) {
    toast.error(error.message)
  }
}

export let getB2BSupplierProductsAPI = async (
  supplierPrefix,
  regions,
  search,
  sortBy,
  sortType,
  page = 0,
  limit = 50
) => {
  try {
    const params = {
      supplier_prefix: supplierPrefix,
      search_attribute: search,
      sort_by: sortBy,
      sort_type: sortType,
      page,
      limit,
    }
    const regionList = Array.isArray(regions)
      ? regions
      : (regions ? [regions] : [])
    if (regionList.length) {
      params.regions = regionList
    }
    const res = await axiosInstance.get(`/b2b_supplier_products`, {
      params,
      paramsSerializer: {
        indexes: null,
      },
    })
    return res.data
  } catch (error) {
    toast.error(error.message)
    return { products: [], has_next: false }
  }
}

export let updateWholesaleEntryAPI = async ({ listId, publicId, field, value, regions }) => {
  const params = { list_id: listId, public_id: publicId }
  const body = { field, value, regions: Array.isArray(regions) ? regions : [] }
  const res = await axiosInstance.post('/wholesale_update_entry', body, { params })
  return res.data
}

export let wholesaleUploadAPI = async (formData) => axiosInstance.post(`/wholesale_upload`, formData, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

export let exportWholesaleListAPI = async ({ listId, favoriteId, regions }) => {
  const hasListId = Boolean(listId)
  const hasFavoriteId = Boolean(favoriteId)
  if (hasListId === hasFavoriteId) {
    throw new Error('Exactly one of listId or favoriteId is required to export')
  }

  try {
    const params = hasListId
      ? { list_id: listId }
      : { favorite_id: favoriteId }

    if (Array.isArray(regions) && regions.length) {
      params.regions = regions
    }

    const res = await axiosInstance.get(`/wholesale_export_list`, {
      params,
      responseType: 'blob',
      paramsSerializer: {
        indexes: null,
      },
    })

    return res
  } catch (error) {
    toast.error(error.message)
    throw error
  }
}

export let getWholesaleAllFilesAPI = async () => {
  try {
    let res = await axiosInstance.get(`/wholesale_all_files`)
    return res.data.all_files
  } catch (error) {
    toast.error(error.message)
  }
}

export let getWholesaleSettingsAPI = async () => {
  try {
    let res = await axiosInstance.get('/wholesale/settings')
    return res.data
  } catch (error) {
    toast.error(error.message)
    throw error
  }
}

export let updateWholesaleSettingsAPI = async ({ fullfillment_type, marketplace, fbm_shipping_cost }) => {
  try {
    let payload = { fullfillment_type }

    if (marketplace) {
      payload.marketplace = marketplace
    }

    if (fbm_shipping_cost != null) {
      payload.fbm_shipping_cost = fbm_shipping_cost
    }

    let res = await axiosInstance.post('/wholesale/settings', payload)
    return res.data
  } catch (error) {
    toast.error(error?.response?.data?.message || error.message)
    throw error
  }
}

export let getWholesaleAllFavoriteAPI = async () => {
  let response = await axiosInstance.get(`/show_all_favorite`)
  return response.data.all_favorite
}

export let createWholesaleFavoriteAPI = async (data) => {
  let response = await axiosInstance.post('/create_favorite', null, { params: data })
  return response.data
}

export let checkFavoriteDealAPI = async (id) => {
  let response = await axiosInstance.get(`/check_favorite_deal?deal_id=${id}`)
  return response.data
}

export let addFavoriteDealAPI = (data) => axiosInstance.post('/add_favorite', null, { params: data })

export let removeFavoriteDealAPI = (data) => axiosInstance.post('/remove_favorite', null, { params: data })

export let deleteFavoriteAPI = (favoriteId) => axiosInstance.post(`/delete_favorite?favorite_id=${favoriteId}`)

export let deleteWholesaleListAPI = (listId) => axiosInstance.post(`/delete_wholesale_list?list_id=${listId}`)


export let postWholesaleAIResponseAPI = async ({ asin, region, cost }) => {
  try {
    let payload = {}
    if (asin !== undefined) {
      payload.asin = asin
    }
    if (region) {
      payload.region = region
    }
    if (cost !== undefined && cost !== null && cost !== '') {
      payload.buyprice = cost
    }

    let res = await axiosInstance.post('/get_ai_response', payload)
    return res.data
  } catch (error) {
    toast.error(error.message)
    throw error
  }
}

export let getStoreSearchAPI = async (application, regions, search, sortBy, sortType, page = 0, limit = 10) => {
  try {
    const res = await axiosInstance.get(`/${application}_products`, {
      params: {
        regions,
        search_attribute: search,
        sort_by: sortBy,
        sort_type: sortType,
        page,
        limit,
      },
      paramsSerializer: {
        indexes: null
      }
    })
    return res.data
  } catch (error) {
    toast.error(error.message)
  }
}

export let exportSpyListAPI = async (regions) => {
  try {
    const params = {}
    if (Array.isArray(regions) && regions.length) {
      params.regions = regions
    }

    const res = await axiosInstance.get(`/spy_export_list`, {
      params,
      responseType: 'blob',
      paramsSerializer: {
        indexes: null,
      },
    })

    return res
  } catch (error) {
    // responseType blob: auch Fehler-JSON kommt als Blob an -- erst auspacken,
    // sonst sieht der User nur ein nichtssagendes "Request failed with 400".
    let message = error.message
    if (error?.response?.data instanceof Blob) {
      try {
        const parsed = JSON.parse(await error.response.data.text())
        if (parsed?.error) {
          message = parsed.error
        }
      } catch { /* kein JSON im Blob -> generische Meldung behalten */ }
    }
    toast.error(message)
    throw error
  }
}

export let saveColumnSettingsAPI = async (module, payload) => {
  try {
    await axiosInstance.post('/safe_rows', payload, {
      params: { module },
    })
  } catch (error) {
    toast.error(error.message)
    throw error
  }
}

export let getColumnSettingsAPI = async (module) => {
  try {
    const res = await axiosInstance.get('/get_rows', {
      params: { module },
    })
    return res.data
  } catch (error) {
    toast.error(error.message)
    throw error
  }
}

export let postOnboardingInfoAPI = async (data) => {
  let response = await axiosInstance.post('/onboarding', data)
  return response.data
}

export let getStripeCheckoutUrlAPI = async (plan) => {
  try {
    const response = await axiosInstance.get('/stripe/checkout', {
      params: { plan }
    })
    return response.data
  } catch (error) {
    toast.error(error?.response?.data?.message || error.message)
    throw error
  }
}

export let postChurnDataAPI = async (data) => {
  let response = await axiosInstance.post('/chrun_data', data)
  return response.data
}
